<template>
  <v-btn
    color="blue"
    dark
    x-large
    block
    class="px-12 py-8 my-2 round-corner justify-center align-center"
    @click="cloneCollection"
  >
    Fazer backup dos vídeos
  </v-btn>
</template>

<script>
// import firebase from 'firebase'
import db from '@/firebase/init'
import moment from 'moment'

export default {
  name: "BackupBtn",
  data() {
    return {
      videos: []
    }
  },
  methods: {
    cloneCollection() {
      // console.log('oi')
      this.videos = []

      db.collection('videos')
        .orderBy("ts", "desc")
        .get()
        .then(snapshot => {
          // console.log(snapshot.docs)
          snapshot.docs.forEach(doc => {
            // console.log(doc.data())
            this.videos.push(doc.data())
          });
          console.log(moment().format('YYYY-MM-DD') + "_" + moment.now(), this.videos)
          db.collection('videos-bckp')
            .doc(moment().format('YYYY-MM-DD') + "_" + moment.now())
            .set({
              videos: this.videos
            })
            .then(() => {
              console.log("Backup feito com sucesso")
            })
            .catch((e) => {
              console.log("Ops, parece que ocorreu um erro: ", e)
            })
        })
    },
  },
  mounted() {
    moment.locale("pt-br");
  }
}
</script>